/* eslint-disable import/no-anonymous-default-export */
export default {
  fam: {
    medium: "Poppins-Medium",
    bolder: "Poppins",
    regular: "Poppins-Regular",
    light: "Poppins-Light",
    bold: "Poppins-SemiBold",
  },
  color: {
    grey: "rgb(83,86,90)",
    blue: "rgb(0,156,207)",
    white: "#f3f3f3",
  },
};
